import React, { useState } from 'react';
import { APITypes } from '../../../../primary-record-types';
import Stack, { contentStackSpacing } from '../../../v2BaseComponents/Stack';
import Text from '../../../v2BaseComponents/Text';
import { ChipSet } from '../../../v2BaseComponents/Chip';
import getNoteTags from '../utils/getNoteTags';
import getNoteLinkState from '../utils/getNoteLinkState';
import NoteLinkPill from './NoteLinkPill';
import getName from '../../../../utils/getName';
import IconButton from '../../../v2BaseComponents/IconButton';
import NoteDetailsModal from './NoteDetailsModal';

export type NoteDetailsHeaderOwnProps = {
    note: APITypes.notesService.NoteDetails;
    /**
     * Rendered at the end of the title row. A screen that can open the note's counterpart passes a pill that does;
     * when nothing is passed, the note's link state is shown as a plain pill so no surface loses it.
     */
    trailing?: React.ReactNode;
};

export type NoteDetailsHeaderProps = NoteDetailsHeaderOwnProps;

const NoteDetailsHeader: React.FC<NoteDetailsHeaderProps> = (props) => {
    const [isInfoPopupOpen, setIsInfoPopupOpen] = useState(false);
    const linkState = getNoteLinkState(props.note);
    const trailing =
        props.trailing === undefined && linkState ? (
            <NoteLinkPill state={linkState} testID={`note-link-pill-${linkState}`} />
        ) : (
            props.trailing
        );

    return (
        <>
            <Stack vertical fullWidth space={contentStackSpacing} testID="note-details-header">
                <Stack horizontal fullWidth justify="space-between" align="flex-start" space={2}>
                    <Text variant="h4" style={{ flex: 1 }}>
                        {props.note.title}
                    </Text>
                    {trailing || null}
                </Stack>
                <Stack horizontal space={0}>
                    <Text variant="body-2">
                        by{' '}
                        {props.note.originSource?.label ||
                            props.note.createdBySourceLabel ||
                            (props.note.createdBy ? getName(props.note.createdBy) : '')}
                    </Text>
                    <IconButton
                        icon="Info"
                        variant="minimal"
                        onPress={() => setIsInfoPopupOpen(true)}
                        customSize="chat-button-icon"
                        style={{
                            cursor: 'pointer',
                            width: 18,
                            height: 18,
                            borderRadius: 9,
                            paddingLeft: 5,
                            paddingBottom: 5,
                        }}
                    />
                </Stack>
                {getNoteTags(props.note)?.length ? (
                    <ChipSet
                        chips={getNoteTags(props.note).map((_) => ({
                            title: _.title,
                            highlight: true,
                            testID: _.testID,
                        }))}
                    />
                ) : null}
            </Stack>

            <NoteDetailsModal note={props.note} isVisible={isInfoPopupOpen} onClose={() => setIsInfoPopupOpen(false)} />
        </>
    );
};

export default React.memo(NoteDetailsHeader);
